{
  "form": {
    "input_placeholder": "Ƙara aiki…",
    "parseWithAi_aria": "Tantance aiki da AI",
    "parseWithAi_title": "Tsaftace da saita fifiko da AI",
    "priorityLabel_aria": "Fifikon aiki",
    "add": "Ƙara",
    "signInForAi": "Shiga don amfani da fasalolin AI.",
    "aiUnavailable": "AI babu. Sake gwadawa.",
    "saveTo": "Ajiye a",
    "saveTo_aria": "Ajiye a {{list}}",
    "saveToSynced_aria": "Ajiye a {{list}}, {{provider}}",
    "addedTo": "An ƙara zuwa {{list}}",
    "addedToSynced": "An ƙara zuwa {{list}} · {{provider}}",
    "show": "Nuna"
  },
  "priority": {
    "Critical": "Mai matuƙar muhimmanci",
    "High": "Babba",
    "Medium": "Matsakaici",
    "Low": "Ƙarami"
  },
  "item": {
    "edit_aria": "Gyara aiki",
    "delete_aria": "Share aiki",
    "addStep": "Ƙara mataki",
    "addStep_placeholder": "Ƙara mataki…",
    "addStep_aria": "Ƙara mataki zuwa {{task}}",
    "steps_group_aria": "Matakan {{task}}",
    "steps_progress_aria": "An kammala mataki {{done}} daga cikin {{count}}",
    "completeSteps_aria": "{{task}}. Zai kuma kammala matakai {{count}} da ba a gama ba"
  },
  "list": {
    "title": "Ayyuka",
    "newListFallback": "Sabon Jeri",
    "completedMeta": "{{completed}} cikin {{total}} an gama",
    "deleteConfirm": "Share \"{{name}}\"?",
    "rename_title": "Sake suna",
    "deleteList_title": "Share jeri",
    "newListName_placeholder": "Sunan jeri…",
    "newList": "Sabon jeri",
    "done": "An gama",
    "emptyTitle": "Babu ayyuka har yanzu",
    "emptySubtitle": "Ƙara ɗaya a ƙasa don farawa.",
    "noFilterMatch": "Babu ayyukan da suka dace da wannan tace.",
    "createIn": "Ƙirƙira a",
    "inDestination": "a {{destination}}",
    "createIn_aria": "Ƙirƙira a {{destination}}",
    "createInAccount_aria": "Ƙirƙira a {{destination}}, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "Ana ƙirƙira a {{destination}}…",
    "createFailed": "Ba a iya ƙirƙirar “{{name}}” a {{destination}} ba.",
    "createLimit": "{{destination}} ya kai iyakar jerin sunaye.",
    "keepInRhemn": "Bar shi a Rhemn"
  },
  "filter": {
    "label": "Tace",
    "all": "Duka"
  },
  "voice": {
    "mic_aria": "Ƙara ayyuka da murya",
    "mic_title": "Faɗi ayyukanka — za a jera su bisa fifiko da lokaci",
    "stop_aria": "Tsaya a jera ayyuka",
    "recording": "Ana rikodi",
    "sorting": "Ana jera ayyukanka…",
    "stripTitle": "Ayyukan da aka ji",
    "stripCount": "{{checked}} daga {{total}}",
    "discard": "Yar da",
    "addN": "Ƙara {{count}}",
    "addZero": "Ƙara",
    "adding": "Ana ƙarawa…",
    "parseFallback": "Ba a iya jerawa ba — kalmominka na cikin akwatin.",
    "nothingHeard": "Ba a ji komai ba — sake gwadawa.",
    "micDenied": "An toshe makirufo — ba da izini a saituna.",
    "gateBody": "Faɗi ayyukanka — a jera bisa fifiko da lokacin salla. Tare da Pro.",
    "listen_aria": "Ana saurara — faɗi ayyukanka"
  }
}
